<template>
 <div class="dib">
   <Upload ref="upload"
      :show-upload-list="false"
      :on-success="handleSuccess" :format="['jpg','jpeg','png']"
      :max-size="2048" :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize"
      :before-upload="beforeUpload"
      :name="uploadName"
      :action="uploadUrl"
      :data="uploadData"
    >
      <Icon title="上传图片" class="btn-cursor" type="ios-image-outline" size="24"/>
      <span v-show="false">{{item[nameModelName]}}</span>
  </Upload>
</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ipsosImageUpload',
  props: ['item', 'urlField', 'nameField'],
  data () {
    let { urlField, nameField } = this
    urlField = urlField || 'imgUrl'
    nameField = nameField || 'imgName'
    return {
      urlModelName: urlField,
      nameModelName: nameField,
      uploadUrl: '',
      uploadName: process.env.UPLOAD_NAME,
      uploadData: {
        surveryId: ''
      }
    }
  },
  components: {

  },
  watch: {
    surveyId (newValue) {
      this.uploadData.surveyId = newValue
    }
  },
  computed: {
    ...mapState({
      surveyId: ({ Question }) => Question.surveyId
    })
  },
  methods: {
    handleUpload () {
      this.$refs.upload.handleClick()
    },
    handleSuccess (res, file) {
      this.$emit('update:loading', false)
      // process.env.IMG_FILE_PATH
      const imgUrl = res.data
      const { item, urlModelName, nameModelName } = this
      if (item) {
        item[urlModelName] = imgUrl
        item[nameModelName] = file.name
      }
      this.$emit('handleSuccess', res, file)
    },
    handleError () {
      this.$ipsosMessage({
        title: '上传结果',
        type: 'error',
        message: '上传失败！'
      })
      this.$emit('update:loading', false)
      /* const { item, type, urlModelName, nameModelName } = this
      if (type === 'img') {
        item[urlModelName] = process.env.UPLOAD_URL
        item[nameModelName] = process.env.UPLOAD_NAME
      } else {
        item[urlModelName] = process.env.UPLOAD_URL
        item[nameModelName] = process.env.UPLOAD_NAME
        item.avUrl = ''
      } */
    },
    handleFormatError (file) {
      this.$ipsosMessage({
        title: '上传结果',
        type: 'error',
        message: '上传失败！'
      })
    },
    handleMaxSize (file) {
      this.$ipsosMessage({
        title: '上传结果',
        type: 'warning',
        message: '超过最大文件大小2M！'
      })
    },
    beforeUpload () {
      this.$emit('update:loading', true)
    }
  },
  created () {

  },
  mounted () {
    this.uploadUrl = `${this.$UPLOAD_URL}` || process.env.UPLOAD_URL
    this.uploadData.surveyId = this.surveyId
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/plugin/element/DubuImageUpload.vue